import React, { memo, useMemo } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { AppView, rem } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import { useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { AccountTypeDisplayLong } from 'features/invest/constants';
import { getHasAccountsHeldElsewhere } from 'features/invest/utils';
import { selectOnboardingTradingAccountForOnboardingFunnel, selectHideFundingAccountAndAutoinvestFromInvestOnboarding, } from 'features/invest/reducers/selectors';
import Header from './Header';
import ProgressCard from './ProgressCard';
import FirstTradeProgressCard from './FirstTradeProgressCard';
import UnderReviewProgressCard from './UnderReviewProgressCard';
import AccountCreatedProgressCard from './AccountCreatedProgressCard';
import FundSecclAccountProgressCard from './FundSecclAccountProgressCard';
import TransferExistingProductProgressCard from './TransferExistingProductProgressCard';
const OnboardingFunnel = ({ status, accountId }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const account = useAppSelector(selectOnboardingTradingAccountForOnboardingFunnel);
    const hideFundingAccountAndAutoinvestFlow = useAppSelector(selectHideFundingAccountAndAutoinvestFromInvestOnboarding);
    const hasAccountsHeldElsewhere = getHasAccountsHeldElsewhere(account?.account);
    const content = useMemo(() => {
        if (!hideFundingAccountAndAutoinvestFlow &&
            (account?.hasPostOpenInstructions || account?.account.accountType === 'JISA')) {
            return (<>
          <ProgressCard title={`${AccountTypeDisplayLong[account.account.accountType]} account created`} completed lightBg/>
          <ProgressCard title="Autoinvest set up" completed lightBg/>
          <UnderReviewProgressCard status={status} isLastStep={!hasAccountsHeldElsewhere}/>
          {!!hasAccountsHeldElsewhere && <TransferExistingProductProgressCard status={status}/>}
        </>);
        }
        return (<>
        <AccountCreatedProgressCard />
        <UnderReviewProgressCard status={status}/>
        <FundSecclAccountProgressCard status={status} accountId={accountId}/>
        <FirstTradeProgressCard status={status}/>
      </>);
    }, [
        account?.account.accountType,
        account?.hasPostOpenInstructions,
        accountId,
        hasAccountsHeldElsewhere,
        hideFundingAccountAndAutoinvestFlow,
        status,
    ]);
    return (<AppView type="secondary" withFrame={false}>
      <StatusBar animated barStyle="dark-content"/>
      <Header status={status} contentContainerStyle={paddingHorizontalStyle}/>
      <ScrollView contentContainerStyle={[styles.scrollView, paddingHorizontalStyle]}>{content}</ScrollView>
    </AppView>);
};
const styles = StyleSheet.create({
    scrollView: {
        paddingBottom: rem(16),
    },
});
export default memo(OnboardingFunnel);
